(function(){function setMainWrapperPadding(){var footer=document.querySelector(".footerWrapper"),footerHeight=footer.offsetHeight,mainWrapper=document.querySelector(".mainWrapper");mainWrapper.style.marginBottom=footerHeight+"px"}setMainWrapperPadding(),window.addEventListener("resize",function(){setMainWrapperPadding()})})();

// Fix: theme-hot-reload.js fires shopify:section:load unconditionally, causing
// Broadcast's init function I(document) to register duplicate click listeners
// on the filter toggle button ([aria-controls="filter-groups"]). Two identical
// listeners mean every click opens the filter panel and immediately closes it
// again on the same event -- looks like the page freezing, mostly visible on
// mobile where the toggle (rather than an always-open panel) is actually used.
// This intercepts the click in the capture phase, before theme.js's duplicate
// bubble-phase handlers run, and owns the toggle entirely.
(function () {
  function initFilterToggleFix() {
    var btn = document.querySelector('[aria-controls="filter-groups"]');
    var panel = document.getElementById('filter-groups');
    if (!btn || !panel) return;

    // Sync panel state with the button's initial aria-expanded value
    // (desktop starts expanded under filter_layout: inline-open)
    if (btn.getAttribute('aria-expanded') === 'true') {
      panel.classList.add('expanded');
    }

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();

      var isOpen = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      panel.classList.toggle('expanded');

      if (!isOpen) {
        // Ensure the panel can actually animate open on mobile
        panel.classList.remove('no-mobile-animation');
      }
    }, true); // capture phase -- runs before theme.js's duplicate bubble-phase handlers
  }

  window.addEventListener('load', initFilterToggleFix);
})();

// Fix: the logos section renders each brand logo as a carousel cell, and the
// carousel binds a click listener to every .logos__slide that calls
// preventDefault() on all clicks (a drag guard that never releases). Result:
// the brand logo links on the homepage never navigate. This capture-phase
// handler runs before the carousel's bubble-phase listener and performs the
// navigation itself. Modifier-clicks and swipes are left alone.
(function () {
  var startX = 0;
  var startY = 0;

  document.addEventListener('pointerdown', function (event) {
    startX = event.clientX;
    startY = event.clientY;
  }, true);

  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('.logos__slide__link');
    if (!link) return;

    // let ctrl/cmd/shift/alt/middle-click behave normally (open in new tab etc.)
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    // if the pointer moved, this was a swipe on the carousel, not a click
    if (Math.abs(event.clientX - startX) > 8 || Math.abs(event.clientY - startY) > 8) return;

    var href = link.getAttribute('href');
    if (!href) return;

    event.stopPropagation();
    window.location.href = href;
  }, true); // capture phase -- runs before the carousel's preventDefault handler
})();
